import { useDispatch } from 'react-redux';

import { useComplianceLevelState, useDeviceState } from '@/hooks/store';
import { IS_GDPR_LIMITED, IS_LIMITED } from '@/store/complianceLevel/types';
import { setUser } from '@/store/user/actions';
import { User } from '@/store/user/types';
import { calmLogger } from '@/utils/calmLogger';
import { postMe } from '@/utils/endpoints';
import { CalmAuthMethods, setUserCookies } from '@/utils/privacyCookies';
import { setNextLocaleCookie } from '@/utils/setNextLocaleCookie';

export default function useSetupClassicUserAfterAuth() {
	const dispatch = useDispatch();
	const complianceLevel = useComplianceLevelState();
	const device = useDeviceState();

	const setupUserAfterAuth = async (user: User, authMethod?: CalmAuthMethods) => {
		setUserCookies(user, authMethod);
		setNextLocaleCookie(device?.language);
		dispatch(setUser(user));

		const has_opted_in_limited_data_use =
			complianceLevel === IS_GDPR_LIMITED || complianceLevel === IS_LIMITED;

		await postMe({
			compliance_level: complianceLevel,
			has_opted_in_limited_data_use,
		}).catch(error =>
			calmLogger.error('Error in useSetupUserAfterAuth postMe', { has_opted_in_limited_data_use }, error),
		);
	};

	return setupUserAfterAuth;
}
